import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin, Clock } from "@phosphor-icons/react";
import { BUSINESS } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-[var(--ji-border)] bg-[var(--ji-surface-alt)]">
      <div className="ji-container py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center justify-center w-10 h-10 text-white font-bold"
              style={{ background: "var(--ji-primary)", borderRadius: 4, fontFamily: "Cabinet Grotesk" }}>JI</span>
            <div>
              <div style={{ fontFamily: "Cabinet Grotesk" }} className="text-xl font-bold tracking-tight">
                Joseph Industries
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-[var(--ji-muted)]">
                Family-owned · Louisiana
              </div>
            </div>
          </div>
          <p className="mt-6 text-[var(--ji-muted)] leading-relaxed max-w-sm">
            Appliance repair &amp; installation, on-demand courier services, and home preservation — one family-owned crew across southern Louisiana. Free estimates &amp; quotes on every job.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="ji-overline mb-4">Contact</div>
          <ul className="space-y-3">
            {BUSINESS.phones.map((p) => (
              <li key={p.tel}>
                <a data-testid={`footer-phone-${p.tel}`} href={`tel:${p.tel}`} className="inline-flex items-center gap-2 hover:text-[var(--ji-accent)]">
                  <Phone size={16} weight="bold" /> {p.display}
                  <span className="text-xs text-[var(--ji-muted)]">{p.label}</span>
                </a>
              </li>
            ))}
            {BUSINESS.emails.map((e) => (
              <li key={e}>
                <a data-testid={`footer-email-${e}`} href={`mailto:${e}`} className="inline-flex items-center gap-2 hover:text-[var(--ji-accent)] break-all">
                  <EnvelopeSimple size={16} weight="bold" /> {e}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="ji-overline mb-4">Hours</div>
          <ul className="space-y-2">
            {BUSINESS.hours.map((h) => (
              <li key={h.day} className="flex items-center gap-2 text-sm">
                <Clock size={14} weight="bold" className="text-[var(--ji-accent)]" />
                <span className="w-24 text-[var(--ji-muted)]">{h.day}</span>
                <span>{h.time}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="ji-overline mb-4">Sitemap</div>
          <ul className="space-y-2 text-sm">
            {[
              ["Home", "/"], ["Services", "/services"], ["Shop", "/shop"], ["Service Area", "/service-area"], ["About", "/about"],
              ["Careers", "/careers"], ["Estimate", "/estimate"], ["Reviews", "/reviews"], ["Refer & Earn $25", "/refer"], ["Deposit", "/deposit"], ["Book Diagnostic", "/diagnostic"], ["Contact", "/contact"],
              ["Appliance Install Guide", "/guides/appliance-installation"],
              ["Courier Logistics Guide", "/guides/courier-logistics"],
              ["Home Preservation Guide", "/guides/home-preservation"],
              ["Privacy Policy", "/privacy"], ["Terms of Service", "/terms"],
            ].map(([l, t]) => (
              <li key={t}><Link to={t} className="hover:text-[var(--ji-accent)]">{l}</Link></li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-[var(--ji-border)]">
        <div className="ji-container py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[var(--ji-muted)]">
          <div className="inline-flex items-center gap-2">
            <MapPin size={14} weight="bold" /> {BUSINESS.serviceAreaLong}
          </div>
          <div className="flex items-center gap-4 flex-wrap">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-[var(--ji-accent)]">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[var(--ji-accent)]">Terms of Service</Link>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-[var(--ji-accent)]">Admin</Link>
            <span>© {new Date().getFullYear()} Joseph Industries LLC · Licensed &amp; Insured</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
